function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.533 9.04306C19.3935 9.04306 19.2541 8.99141 19.1456 8.88294C17.6684 7.40571 15.2614 7.40571 13.7842 8.88294C13.5724 9.09471 13.2212 9.09471 13.0094 8.88294C12.7976 8.67117 12.7976 8.31994 13.0094 8.10817C14.9154 6.20223 18.0144 6.20223 19.9204 8.10817C20.1322 8.31994 20.1322 8.67117 19.9204 8.88294C19.8119 8.99141 19.6725 9.04306 19.533 9.04306Z",
  fill: "#00A94F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0506 10.5205C17.9112 10.5205 17.7717 10.4689 17.6632 10.3604C17.343 10.0402 16.9195 9.86454 16.4649 9.86454C16.0104 9.86454 15.5868 10.0402 15.2666 10.3604C15.0548 10.5722 14.7036 10.5722 14.4918 10.3604C14.2801 10.1486 14.2801 9.7974 14.4918 9.58563C15.0187 9.05878 15.716 8.76953 16.4649 8.76953C17.2139 8.76953 17.9112 9.05878 18.438 9.58563C18.6498 9.7974 18.6498 10.1486 18.438 10.3604C18.3347 10.4637 18.1901 10.5205 18.0506 10.5205Z",
  fill: "#00A94F"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.4669 12.2921C16.8719 12.2921 17.2003 11.9637 17.2003 11.5586C17.2003 11.1536 16.8719 10.8252 16.4669 10.8252C16.0618 10.8252 15.7334 11.1536 15.7334 11.5586C15.7334 11.9637 16.0618 12.2921 16.4669 12.2921Z",
  fill: "#00A94F"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M21.0394 7.53457C20.8999 7.53457 20.7605 7.48292 20.652 7.37445C18.3432 5.06563 14.5881 5.06563 12.2793 7.37445C12.0675 7.58622 11.7163 7.58622 11.5045 7.37445C11.2928 7.16268 11.2928 6.81145 11.5045 6.59968C12.832 5.27223 14.5933 4.54395 16.4682 4.54395C18.3432 4.54395 20.1045 5.27223 21.432 6.59968C21.6437 6.81145 21.6437 7.16268 21.432 7.37445C21.3235 7.48292 21.1789 7.53457 21.0446 7.53457H21.0394Z",
  fill: "#00A94F"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.8203 11.037C13.5311 10.7478 13.3864 10.3707 13.3813 9.99364C12.9835 9.99364 12.6168 9.83352 12.3327 9.5546C12.0487 9.27052 11.8937 8.89346 11.8937 8.49575C11.8937 8.49575 11.8937 8.49575 11.8937 8.49058C11.4908 8.49058 11.1138 8.33563 10.8348 8.05154C10.5508 7.76746 10.3958 7.3904 10.3958 6.99269C10.3958 6.59497 10.5508 6.21275 10.8348 5.93383C11.8059 4.96278 12.9835 4.28615 14.2697 3.91942C13.9391 3.37191 13.3399 3.00002 12.653 3.00002H4.88975C3.84123 2.99486 2.99414 3.84194 2.99414 4.89047V19.6938C2.99414 20.7423 3.84123 21.5894 4.88975 21.5894H12.6478C13.6963 21.5894 14.5434 20.7423 14.5434 19.6938V11.4296C14.2697 11.3676 14.0217 11.2384 13.8203 11.037ZM5.03954 14.8386H3.78957V9.35316H5.03954V14.8386ZM6.12422 11.6517L6.33083 11.3831L6.53227 11.1248L6.58909 11.0473L7.51365 9.84902C7.68927 9.62175 7.90104 9.35316 8.39689 9.35316H9.51773L7.40002 12.0959L9.51773 14.8386H8.39689C7.90104 14.8386 7.68927 14.57 7.51365 14.3427L5.77816 12.101L6.12422 11.6568V11.6517ZM10.2667 20.0864H7.29155C6.99197 20.0864 6.74921 19.8436 6.74921 19.5388C6.74921 19.2341 6.99197 18.9913 7.29155 18.9913H10.2667C10.5663 18.9913 10.809 19.2341 10.809 19.5388C10.809 19.8436 10.5663 20.0864 10.2667 20.0864ZM13.748 13.4595H12.3637V14.8437H11.6406V13.4595H10.2563V12.7363H11.6406V11.3521H12.3637V12.7363H13.748V13.4595Z",
  fill: "#00A94F"
});

function SvgKplus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKplus);
export default __webpack_public_path__ + "static/media/kplus.594933d3.svg";
export { ForwardRef as ReactComponent };